import { MobileStepper, styled } from '@mui/material'

import { Button } from '@collaborate-health/uikit'

export const Stepper = styled(MobileStepper)(({ theme }) => ({
  flexGrow: 1,
  padding: 0,
  pt: theme.spacing(1),
}))

export const StepperButton = styled(Button)({
  minWidth: 90,
})

